module.exports = __webpack_public_path__ + "static/media/corporateStep4.b9db4c28.svg";